import { PackItem as PackItemStyled, PackLeft, PackBonus, PackAmount, PackRight, RubBlock, PackPrice } from './Packages.styled';
import CurrencyIcon from '../CurrencyIcon';

export default function PackItem({ pack, promoApplied, onBuy, rubPrice }) {
	return (
		<PackItemStyled onClick={() => onBuy(pack)}>
			<PackLeft>
				<PackAmount>
					<CurrencyIcon size={16} style={{ marginRight: 4 }} />
					{pack.tokens.toLocaleString()}
				</PackAmount>
				{promoApplied && pack.bonus > 0 && (
					<PackBonus highlight={true}>
						{/* <CurrencyIcon size={16} style={{ marginRight: 4 }} /> */}
						+{pack.bonus.toLocaleString()}
					</PackBonus>
				)}
			</PackLeft>
			<PackRight>
				<RubBlock>
					≈ {rubPrice ? rubPrice.toLocaleString() : '?'} ₽
				</RubBlock>
				<PackPrice>{pack.stars} ⭐</PackPrice>
			</PackRight>
		</PackItemStyled>
	);
} 